import { TestComponent } from './components/test-component/test-component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

// Import Components
import { RegisterComponent } from './components/register/register.component';
import { LoginComponent } from './components/login/login.component';
import { ForgotComponent } from './components/forgot/forgot.component';
import { ErrorComponent } from './components/error/error.component';
import { ProfileComponent } from './components/profile/profile.component';
import { AuthGuard } from './helpers/auth.guard';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { PreregistrationComponent } from './components/core/users/preregistration/preregistration.component';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe.component';
import { NexiPaymentResultComponent } from './components/nexi-payment-result/nexi-payment-result.component';
import { AppPaymentComponent } from './components/app-payment/app-payment.component';


export const routes: Routes = [
  {
    path: '404',
    component: ErrorComponent,
    data: {
      breadcrumbs: 'Error 404'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      breadcrumbs: 'Login Page'
    }
  },
  {
    path: 'changePassword',
    component: ChangePasswordComponent,
    data: {
      breadcrumbs: 'Change Password'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      breadcrumbs: 'Register Page'
    }
  },
  {
    path: 'forgot',
    component: ForgotComponent,
    data: {
      breadcrumbs: 'Errore 404'
    }
  },
  {
    path: 'preregistration/:email',
    component: PreregistrationComponent,
    data: {
      breadcrumbs: 'Preregistrazione'
    },
  },
  {
    path: 'unsubscribe',
    component: UnsubscribeComponent,
    data: {
      breadcrumbs: 'Sottoiscrizione cancellata'
    }
  },
  {
    path: 'nexi-payment-result/:result/:id',
    component: NexiPaymentResultComponent,
  },
  {
    path: 'app-payment/:id',
    component: AppPaymentComponent,
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumbs: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'core',
        loadChildren: () => import('./components/core/core.module').then(m => m.CoreModule)
      },
      {
        path: 'profile',
        component: ProfileComponent,
        data: {
          breadcrumbs: 'Profilo utente'
        },
      },
      {
        path: 'test',
        component: TestComponent,
        data: {
          breadcrumbs: 'Test'
        }
      }
    ]
  },
  { path: '**', component: ErrorComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
